import React, { useState } from 'react';
import { Input } from './input';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Password input with a show/hide toggle button on the right.
 * Accepts all standard Input props; visually identical to Input when hidden.
 *
 * Usage:
 *   <PasswordInput value={pwd} onChange={...} placeholder="..." />
 */
export const PasswordInput = React.forwardRef(function PasswordInput(
  { className, 'data-testid': testId, ...props },
  ref
) {
  const [visible, setVisible] = useState(false);
  const Icon = visible ? EyeOff : Eye;

  return (
    <div className="relative w-full">
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        className={cn('pr-10', className)}
        data-testid={testId}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible(v => !v)}
        aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
        data-testid={testId ? `${testId}-toggle` : 'password-toggle'}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-7 h-7 rounded-md flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
      >
        <Icon className="w-4 h-4" />
      </button>
    </div>
  );
});
